import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

import { ReasonOfAllowanceListService } from '../../service/reason-of-allowance-list/reason-of-allowance-list.service';

@Component({
	selector: 'app-reason-of-allowance-list',
	templateUrl: './reason-of-allowance-list.component.html',
	providers: [
		ReasonOfAllowanceListService,
		HttpModule
	]
})
export class ReasonOfAllowanceListComponent implements OnInit {

	private token;
	public reasonOfAllowances: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	reasonOfAllowance: FormGroup;

	constructor(fb: FormBuilder, private reasonOfAllowanceListService: ReasonOfAllowanceListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.reasonOfAllowance = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchClientType(this.reasonOfAllowance.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchClientType(this.reasonOfAllowance.value, this.currentPage, false);
	}

	searchClientType(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.reasonOfAllowanceListService.searchReasonOfAllowance(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.reasonOfAllowances = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchClientType(this.reasonOfAllowance.value, $event, false);
	}
}



// WEBPACK FOOTER //
// ./src/app/reason-of-allowance/component/reason-of-allowance-list/reason-of-allowance-list.component.ts